import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM, type ClickstreamPayload, type ZrmUserInfo } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore';
import { tracker as GTM } from '@zg-rentals/google-tag-manager';

export const analytics = defineAnalytics({ GTM, COMSCORE, CLICKSTREAM });

export const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmUserInfo>>('CLICKSTREAM');

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');

export const trackGtmEvent = analytics.createTrackEvent('GTM');
